<template>
  <section>
    <!-- Sticky Menu  -->
    <SectionBuilderAnchorMenuComponent v-bind="anchorList" />

    <!-- Component List -->
    <AnchorMenuSection
      v-for="section in anchorMenuSections"
      :id="section._key"
      :key="section._key"
      v-bind="section"
    />
  </section>
</template>

<script setup lang="ts">
import SectionBuilderAnchorMenuComponent from './SectionBuilderAnchorMenu.vue';
import AnchorMenuSection from './AnchorMenuSection.vue';
import type { AnchorMenuSections, SectionBuilderAnchorMenu } from '~/sanity/types';

const props = defineProps<AnchorMenuSections>();
const anchorList: SectionBuilderAnchorMenu = {
  _type: 'sectionBuilderAnchorMenu',
  anchorList: props.anchorMenuSections.map((section) => {
    return {
      _type: 'anchorLink',
      _key: section._key,
      label: section.sectionTitle,
      anchorId: section._key,
    };
  }),
};
</script>

<style lang="scss" scoped></style>
